module.exports = "<div id=\"squares\" class=\"row\"></div>\n";